import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "bg-white shadow-card rounded-2xl flex flex-col justify-center items-center" }
const _hoisted_3 = { class: "relative z-50 h-24 w-24 -mt-16 bg-white shadow-card rounded-lg" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col w-full mt-4 mb-8 justify-center items-center" }
const _hoisted_6 = { class: "flex flex-col mb-2" }
const _hoisted_7 = { class: "text-gray-600 text-base font-semibold" }
const _hoisted_8 = { class: "flex flex-row justify-center items-center space-x-2 text-gray-400" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "11",
    r: "3"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 0 1 -2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0z" })
], -1)
const _hoisted_10 = { class: "text-xs uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "w-full justify-center items-center p-2 animate__animated animate__fadeIn animate__delay-0.5s cursor-pointer transform transition duration-300 zoom",
      onClick: ($event: any) => (
      _ctx.$router.push(`/companies/${company?.company_branding?.domain_name}`)
    )
    }, [
      _createElementVNode("a", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "flex flex-col h-48 w-full bg-gray-200 rounded-t-2xl small-hero object-cover",
            style: _normalizeStyle({
            backgroundImage: `url(${company?.company_branding?.background?.url} )`,
            backgroundColor: `${company?.company_branding?.primary_color}`,
          })
          }, null, 4),
          _createElementVNode("div", _hoisted_3, [
            (company?.company_branding?.logo?.url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "object-cover bg-white rounded-lg w-full h-full",
                  src: company?.company_branding?.logo?.url,
                  alt: ""
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(company.visible_name), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(company.company_country.name), 1)
            ])
          ])
        ])
      ])
    ], 8, _hoisted_1))
  }), 128))
}